import { render, staticRenderFns } from "./UrunOzelAlanlar.vue?vue&type=template&id=56eadef7&scoped=true"
import script from "./UrunOzelAlanlar.vue?vue&type=script&lang=js"
export * from "./UrunOzelAlanlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eadef7",
  null
  
)

export default component.exports